import React from "react";
import T from "./Translate/T";

const Footer = () => {
  return (
    <footer id="footer" className="section bg-dark text-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 text-center text-lg-start wow fadeInUp">
            <p className="mb-2 mb-lg-0">
              <T>Copyright</T> © {(new Date().getFullYear())}{" "}
              <a className="fw-600" href="/">
                Carlos A Ramirez
              </a>
              . <T>All Rights Reserved.</T>
            </p>
          </div>
          <div className="col-lg-6 wow fadeInUp">
            <p className="mb-0 text-center text-lg-end">
              {/* Designed by{" "}
              <a className="fw-600" href="https://www.harnishdesign.net/">
                Harnish Design
              </a> */}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;